export interface Approver {
  OnboardingFirmApprovalGroupId?: number;
  OnboardingFirmApprovalGroupDetailId?: number;
  OnboardingClientApproverId?: number;
  ApprovalRequired?: string;
  FirmDetailId?: number;
  ClientTypeCode?: string;
  Email: string;
  ApproverOrder?: number;
  Active?: string | boolean;
  Description?: string;
  Features?: string;
  FeaturesList?: any[];
  FirmId?: number;
  UserRole?: string;
  Role?: string;
  UserName: string;
  UserFullName: string;
  FirstName: string;
  LastName: string;
  FirmName: string;
  ApprovalType: string;
  AutoApprove?: string;
  Displayname?: string;
  ShowInUI?: string;
  ApproverType?: 'FIXED' | 'FIELD' | 'RULE';
  ApproverFieldCode?: string;
  COIApprover?: 'Y' | 'N' | null;
}

export interface ApproverFieldOption {
  id: string;
  label: string;
  value: string;
}

export interface ClientApproverSettingProps {
  allUsers: Approver[];
  selectedApprovers: Approver[];
  approvalCheck: boolean;
  setSelectedApprovers: (approvers: Approver[]) => void;
  fieldsList?: ApproverFieldOption[];
  ruleFieldsList?: ApproverFieldOption[];
  coiApproverGroupLabel?: string;
}

export const COI_REGISTRY_PRIVILEGE_CODE = "COI_REG";
